interface ModulePlaceholderPageProps {
  title: string;
}

export function ModulePlaceholderPage({ title }: ModulePlaceholderPageProps) {
  return (
    <div className="space-y-2">
      <h1 className="text-lg font-semibold">{title}</h1>
      <p className="text-sm text-gray-600">Modulen är aktiverad men ännu inte implementerad i denna fas.</p>
    </div>
  );
}

